export default "__VITE_ASSET__5TOtApq4__ 100w";